<template>
  <div>
    <v-card>
      <v-toolbar>
        <v-toolbar-title>{{ $i18n.translate("Incentive") }} {{ $i18n.translate("Program") }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-row align="center">
          <v-col cols="12" sm="5" class="mt-5">
            <DateTimePickerField
              dense
              v-model="startDate"
              :label="$i18n.translate('Incentives From')"
              onlyDate
              format="YYYY-MM-DD"
              returnFormat="YYYY-MM-DD"
              :max="endDate"
            ></DateTimePickerField>
          </v-col>

          <v-col cols="12" sm="5" class="mt-5">
            <DateTimePickerField
              dense
              v-model="endDate"
              :label="$i18n.translate('To')"
              onlyDate
              format="YYYY-MM-DD"
              returnFormat="YYYY-MM-DD"
              :min="startDate"
            ></DateTimePickerField>
          </v-col>

          <v-col cols="12" sm="2">
            <v-btn color="primary" block :disabled="moment(endDate).isBefore(startDate)" @click="fetchIncentives">{{
              $i18n.translate("View")
            }}</v-btn>
          </v-col>
        </v-row>
      </v-toolbar>

      <v-data-table :headers="headers" :items="incentives" class="elevation-1">
        <template v-slot:item.promotionType="{ item }">
          {{ item.promotionType?.promotionTypeKey }}
        </template>
        <template v-slot:item.effectiveDate="{ item }">
          {{ item.effectiveDate | formatDateClient("MM/DD/YYYY hh:mm a", selectedClient) }}
        </template>
        <template v-slot:item.expirationDate="{ item }">
          {{ item.expirationDate | formatDateClient("MM/DD/YYYY hh:mm a", selectedClient) }}
        </template>

        <template v-slot:item.courseDetails="{ item }">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header @click="fetchCourses(item)"
                >{{ $i18n.translate("View") }} {{ $i18n.translate("Courses") }}</v-expansion-panel-header
              >
              <v-progress-circular indeterminate color="primary" v-if="loading"></v-progress-circular>
              <v-expansion-panel-content v-else>
                <ol class="mb-4">
                  <li v-for="(course, index) in item.courses" :key="index">
                    <v-divider></v-divider>

                    {{ course.name }}
                  </li>
                </ol>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import DateTimePickerField from "../../gapp-components/components/fields/DateTimePickerField.vue";
import moment from "moment";
import { mapGetters } from "vuex/dist/vuex.common.js";

export default {
  components: {
    DateTimePickerField
  },
  name: "IncentivePage",
  data() {
    return {
      today: new Date().toISOString(),
      dateMenuStart: false,
      dateMenuEnd: false,
      selectedClaimProductReportFields: [],
      options: {
        itemsPerPage: 10,
        page: 1
      },
      loading: false,
      startDate: moment()
        .subtract(1, "month")
        .format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      expandedCourses: [],
      incentives: [],
      headers: [
        { text: "Incentive Type", value: "promotionType" },
        { text: "Sale Key", value: "promotionKey" },
        { text: "Sale Description", value: "description" },
        { text: "Start Date", value: "effectiveDate" },
        { text: "End Date", value: "expirationDate" },
        { text: "Course Details", value: "courseDetails" }
      ]
    };
  },
  methods: {
    moment,
    async fetchIncentives() {
      this.loading = true;

      try {
        const fetchPayoutsUrl = "/api/payouts/search";

        const payoutPayload = {
          participant: { id: this.selectedParticipant.id },
          payoutMessage: "Incentive",
          createdAfter: new Date(`${this.startDate}T00:00:00Z`),
          createdBefore: new Date(`${this.endDate}T23:59:59Z`)
        };

        let payouts = await this.$util.fetchPaginatedData(fetchPayoutsUrl, payoutPayload);

        this.incentives = payouts.map(p => p.promotion);
      } catch (error) {
        console.error("Error fetching incentives:", error);
      } finally {
        this.loading = false;
      }
    },
    async fetchCourses(item) {
      if (item.courses && item.courses.length > 0) {
        return; // Courses already loaded
      }
      this.loading = true;
      try {
        const fetchCoursesUrl = "/api/promotionCourses/search";
        let coursesResponse = await this.$util.fetchPaginatedData(fetchCoursesUrl, {
          promotion: { id: item.id },
          effective: true
        });

        item.courses = coursesResponse.map(response => response.course);
        this.expandedCourses[item.id] = item.courses;
      } catch (error) {
        console.error("Error loading courses:", error);
      } finally {
        this.loading = false;
      }
    }
  },
  computed: {
    ...mapGetters(["selectedParticipant", "selectedClient"])
  },
  mounted() {
    this.fetchIncentives();
  }
};
</script>
